import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  toasterSuccess: any
  toasterMessage = ''
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.toasterSuccess = this.data?.toasterSuccess,
      this.toasterMessage = this.data?.toasterContent
  }

  ngOnInit(): void {
  }

}
